import FooterPure from './pure';

const Footer = FooterPure;

export default Footer;